import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalLoadingService {
  private readonly _loadingSubject = new BehaviorSubject(0);
  public loading$ = this._loadingSubject
    .asObservable()
    .pipe(map(result => !!result));

  public show() {
    setTimeout(() => this._loadingSubject.next(this._loadingSubject.value + 1));
  }

  public hide() {
    setTimeout(() => {
      if (this._loadingSubject.value > 0) {
        this._loadingSubject.next(this._loadingSubject.value - 1);
      }
    });
  }
}
